import { jsxs as e, jsx as i } from "react/jsx-runtime";
import g from "classnames";
import r from "./index.es5450.js";
import { NotificationIndicator as x } from "./index.es93.js";
import { Divider as y } from "./index.es18.js";
import { BodyText as a } from "./index.es487.js";
import { UtilityChevronIcon as u } from "./index.es422.js";
const I = {
  small: "4px 0 0 0",
  medium: "12px 0 0 0",
  large: "16px 0 0 0"
}, A = ({
  title: m,
  count: o,
  size: l = "medium",
  showSummary: t = "line",
  showChevron: n,
  hasDivider: c,
  isCollapsed: d,
  color: p = "gray",
  titleVariant: N = "semi-bold",
  onCollapse: f
}) => {
  const h = g(r.root, r[l]), v = t === "line", s = l !== "small";
  return /* @__PURE__ */ e("div", { className: h, role: "section", onClick: f, children: [
    /* @__PURE__ */ e("div", { className: r.row, children: [
      /* @__PURE__ */ i(
        a,
        {
          size: "small",
          variant: N,
          color: p,
          isEllipsis: !0,
          "aria-label": m,
          children: m
        }
      ),
      /* @__PURE__ */ e("span", { className: r.right, children: [
        o && s && (v ? /* @__PURE__ */ i(a, { size: "small", variant: "regular", color: "gray", isEllipsis: !0, children: `(${o} items)` }) : /* @__PURE__ */ i(x, { count: o, limitAt: 99, color: "gray" })),
        n && s && /* @__PURE__ */ i(u, { direction: d ? "down" : "up" })
      ] })
    ] }),
    c && s && /* @__PURE__ */ i("div", { className: r.divider, children: /* @__PURE__ */ i(y, { margin: I[l] }) })
  ] });
};
export {
  A as SectionTitle
};
//# sourceMappingURL=index.es81.js.map
